import { useEffect, useRef } from 'react';

import { consumeMarketplaceRedirect } from '../authentication/login/marketplace-redirect-service';
import { LogService } from '../services/log-service';

/**
 * After Auth0 login, checks for a marketplace-redirect cookie set on the login page.
 * If present, redirects to the marketplace's OAuth accept endpoint and clears the cookie.
 */
export const useMarketplaceRedirect = (): void => {
  const hasChecked = useRef(false);

  useEffect(() => {
    if (hasChecked.current) {
      return;
    }
    hasChecked.current = true;

    const acceptUrl = consumeMarketplaceRedirect();
    if (acceptUrl) {
      LogService.logInfo('Redirecting to marketplace OAuth', { acceptUrl });
      window.location.href = acceptUrl;
    }
  }, []);
};
